import { FpTheme } from '@flicent/fieldpulse-react-component-library-frontend';

import { MetaData } from '@/interfaces';
import { JobApiService } from './job-api.service';


export interface GetJobReportDataRequestParams {
  customerId: string;
  jobIds: string[];
  token: string;
}

interface Response {
  theme: FpTheme;
  meta: MetaData;
}

export const getJobReportDataRequest = (
  { customerId, jobIds, token }: GetJobReportDataRequestParams
): Promise<Response> => {
  return JobApiService.makeRequest<Response>(`/job/customer/${ customerId }/html/preview`, {
    token,
    method: 'POST',
    body: {
      job_ids: jobIds
    },
  });
};